import productApi from "@/service/modules/productApi";
import { Button, Modal, Form, Input, InputNumber, message } from "antd";
import { useState } from "react";

interface Props {
  onClose: Function;
  isWholesaleOpen: boolean;
  productID?: number | undefined;
  productUrl?: string | undefined;
}

export default function Wholesale({ onClose, isWholesaleOpen, productID, productUrl }: Props) {
  const [btnLoading, setBtnLoading] = useState(false)

  const onFinish = async (values: any) => {
    setBtnLoading(true);
    let params = {
      ...values,
    };

    if (productUrl) params.productUrl = productUrl

    try {
      const res = await productApi.wholesale(params);
      const { send } = res.data;
      setBtnLoading(false);
      if (send) {
        message.success("Success");
        onClose();
      } else {
        message.error("Error");
      }
    } catch (error: any) {
      setBtnLoading(false);
      message.error(error.message);
    }
  };

  type FieldType = {
    contactEmail?: string;
    productID?: number;
    productInfo?: string;
    quantity?: number;
  };

  return (
    <Modal
      title=""
      centered
      open={isWholesaleOpen}
      onOk={() => onClose()}
      onCancel={() => onClose()}
      footer={null}
      width={513}
    >
      <div style={{ margin: "0 auto" }}>
        <p
          style={{
            color: "#446CB3",
            fontWeight: "bold",
            fontSize: "16px",
            margin: "27px 0",
          }}
        >
          For orders over 20 pcs or exceeding $2000 (QTY{">"}=5), we&apos;ll
          sort you a top-notch quote. Reach out for more details, cheers!
        </p>
        <Form name="wholesale" layout="vertical" onFinish={onFinish}>
          <Form.Item<FieldType>
            label="Your contact email:"
            name="contactEmail"
            rules={[
              { required: true, message: "Please input your contact email!" },
              { type: "email" },
            ]}
          >
            <Input placeholder="Your Email Address" />
          </Form.Item>

          {productID && (
            <Form.Item<FieldType>
              label="Items you want to bulk buy:"
              name="productID"
              rules={[
                { required: true, message: "Please input your PID number!" },
              ]}
              initialValue={productID}
            >
              <Input
                placeholder="Enter the item's link or PID number (the PID No. is above the product title)"
                disabled
              />
            </Form.Item>
          )}

          {!productID && (
            <Form.Item<FieldType>
              label="Items you want to bulk buy:"
              name="productInfo"
              rules={[
                {
                  required: true,
                  message:
                    "Please input the item's link or PID number (the PID No. is above the product title)",
                },
              ]}
            >
              <Input placeholder="Enter the item's link or PID number (the PID No. is above the product title)" />
            </Form.Item>
          )}

          <Form.Item<FieldType>
            label="How many items do you want?"
            name="quantity"
            rules={[{ required: true, message: "Please input your number!" }]}
          >
            <InputNumber
              style={{ width: "100%" }}
              min={1}
              placeholder="Example:100"
            />
          </Form.Item>

          <Form.Item>
            <Button
              loading={btnLoading}
              htmlType="submit"
              style={{ width: "100%", height: "40px", backgroundColor: '#446CB3', textAlign: 'center', color: '#fff', borderRadius: '0', padding: "0" }}
            >
              Contact Us
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
}
